import {FaTrashAlt} from "react-icons/fa";
import TableRow from "../../UI/table/TableRow";


const SubcontractorProcessRow = ({subcontractorProcess, onClick, onDelete, onToggleUso}) => {
    const handleRowClick = async () => {
        onClick && onClick(subcontractorProcess.IdLav);
    }

    const handleUsoToggle = (event) => {
        event.stopPropagation();
        onToggleUso && onToggleUso(subcontractorProcess.IdTerzLav, subcontractorProcess.rel.uso === 1 ? 0 : 1);
    }

    const handleDelete = async (event) => {
        event.stopPropagation();
        onDelete && onDelete(subcontractorProcess.IdTerzLav)
    }
    console.log(subcontractorProcess)
    return (
        <TableRow onClick={handleRowClick} className='text-sm mb-0.5'>
            <td className="pl-2 ">{subcontractorProcess.Nomelav}</td>
            <td className="pl-2 ">
                {subcontractorProcess.rel.data &&
                !isNaN(Date.parse(subcontractorProcess.rel.data))
                    ? new Date(subcontractorProcess.rel.data).toLocaleDateString('it-IT')
                    : ''
                }
            </td>
            <td className="pl-2 ">{subcontractorProcess.rel.prezzo1}</td>
            <td className="pl-2 ">{subcontractorProcess.rel?.um1?.um}</td>
            <td className="pl-2 ">{subcontractorProcess.rel.prezzo2}</td>
            <td className="pl-2 ">{subcontractorProcess.rel?.um2?.um}</td>
            <td className="pl-2 ">{subcontractorProcess.rel.prezzo3}</td>
            <td className="pl-2 ">{subcontractorProcess.rel?.um3?.um}</td>
            <td className="pl-2 ">
                <div className="w-full flex flex-row items-center justify-center gap-2">
                    <input
                        type="checkbox"
                        checked={Boolean(subcontractorProcess.rel.uso)}
                        onChange={handleUsoToggle}
                        onClick={(e) => e.stopPropagation()}
                        className="h-4 w-4 cursor-pointer"
                        title="Toggle uso"
                    />
                </div>
            </td>
            <td>
                <div className="w-full flex flex-row items-center justify-center gap-2">
                    <FaTrashAlt
                        title="Cancella Lavorazione"
                        onClick={handleDelete}
                        className="cursor-pointer hover:text-red-500"
                    />
                </div>
            </td>
        </TableRow>
    )
};

export default SubcontractorProcessRow;
